import React, { useState, useEffect, memo } from 'react'


import { useInView } from 'react-cool-inview'

import { string, PropTypes } from 'prop-types'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

let SubscribeCard

function SearchSubscription({ keywords = '', pricing = EMPTY_OBJECT }) {
  const [currentState, setState] = useState({
    isLoaded: false,
    value: '',
    error: '',
  })

  const { observe, inView } = useInView({
    threshold: 0.25,
    onEnter: ({ unobserve }) => {
      unobserve() // unobserve to avoid multiple loads if dropdown closed and opened again

      window.customEventTracker({
        name: 'search_subscription_view',
        userId: window.pageConfig?.currentUserId || '',
        event_data: {},
      })
    },
  })

  useEffect(() => {
    if (inView && !SubscribeCard && !!keywords && !pricing?.free) {
      import('./Components/SubscribeCard')
        .then((module) => {
          SubscribeCard = module.default
          setState((prevState) => ({ ...prevState, isLoaded: true }))

          window.customEventTracker({
            name: 'search_subscription_load',
            userId: window.pageConfig?.currentUserId || '',
            event_data: {},
          })
        })
        .catch((err) => {
          console.error(err)
          // To do:
          // sentry error here.
        })
    }
  }, [inView, pricing])

  return (
    <div
      className={`search-subscription ${
        inView ? 'search-subscription--in-view' : ''
      }`}
      ref={observe}
    >
      {currentState.isLoaded && !!SubscribeCard && !pricing?.free && (
        <SubscribeCard />
      )}
    </div>
  )
}

SearchSubscription.propTypes = {
  keywords: string,
  pricing: PropTypes.object,
}

export default memo(SearchSubscription)
